// Code generated by Slice Machine. DO NOT EDIT.

import CallToAction from './CallToAction/index.svelte';
import GameList from './GameList/index.svelte';
import Image from './Image/index.svelte';
import NewsList from './NewsList/index.svelte';
import PageList from './PageList/index.svelte';
import RichText from './RichText/index.svelte';
import TeamList from './TeamList/index.svelte';

export const components = {
	call_to_action: CallToAction,
	game_list: GameList,
	image: Image,
	news_list: NewsList,
	page_list: PageList,
	rich_text: RichText,
	team_list: TeamList
};
